
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 169 149","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61.603 39.66a3.632 3.632 0 00-4.725.546L6.723 94.05a3.64 3.64 0 001.943 6.403 3.63 3.63 0 002.65-.76c.257-.212.486-.458.677-.731L60.15 47.477l31.073 21.117a3.632 3.632 0 004.726-.546l50.882-55.86v34.75a3.635 3.635 0 107.268 0V.545h-.177V0h-47.615a3.638 3.638 0 00-3.638 3.643 3.638 3.638 0 003.638 3.643h35.799L92.676 60.775 61.603 39.66z","fill":"#fff"}}),_c('path',{attrs:{"d":"M165.364 141.723h-11.81V67.677a3.638 3.638 0 10-7.278 0v74.046h-14.537v-86.78c0-.966-.384-1.893-1.066-2.576a3.636 3.636 0 00-5.146 0 3.647 3.647 0 00-1.066 2.576v86.78H109.94v-63.13a3.643 3.643 0 00-3.639-3.642 3.638 3.638 0 00-3.639 3.643v63.129H88.125V89.51a3.642 3.642 0 00-2.225-3.435 3.632 3.632 0 00-4.79 2.018c-.178.45-.264.932-.254 1.417v52.213H66.32V69.497a3.633 3.633 0 00-7.269 0v72.226H44.52V93.147a3.641 3.641 0 00-3.634-3.559 3.633 3.633 0 00-3.634 3.56v48.575H22.72v-28.562a3.647 3.647 0 00-1.036-2.626 3.626 3.626 0 00-2.599-1.094 3.631 3.631 0 00-3.38 2.302 3.647 3.647 0 00-.254 1.418v28.562H3.635a3.637 3.637 0 00-3.639 3.643 3.637 3.637 0 003.639 3.643h161.729a3.643 3.643 0 000-7.286z","fill":"#fff"}})])
          )
        }
      }
    